import React from "react";
import LogoutPage from "../../components/Logout";

const Logout: React.FC = () => {
  return <LogoutPage/>
}

export default Logout
